import "./Hero.css"
import dansvan from "../images/dansVan2.png"
import bikeimg from "../images/whitebike.jpg"
import { useEffect, useState } from "react"
import { Link } from 'react-router-dom';

const Hero = () => {

  let [num,setnum] = useState(null)

  useEffect(()=>{

    let timer1 = setTimeout(()=>{
      num===1?setnum(num+1):(num===2)?setnum(num+1):setnum(1)
    },1500)

    return () => {
      clearTimeout(timer1);
    };
  },[num])

  

  

  return ( 
    <div className="Hero">
      <section className="Hero__TextBox">

        <main className="Hero__TextBox-container">


          <h1 className="Hero__TextBox-box1">Any</h1>

          <div className="Hero__TextBox-box2">
            <h4 style={{
              color:num===1?"white":"#2C5136",
              transition:"1s"
          }}>fix</h4>
            <h4 style={{
              color:num===2?"white":"#2C5136",
              transition:"1s"
          }}>time</h4>
            <h4 style={{
              color:num===3?"white":"#2C5136",
              transition:"1s"
              }}>where</h4>
          </div>
          

          <h6 className="Hero__TextBox-box3">My Services</h6>

          <h5 className="Hero__TextBox-box4">What do you need today?</h5>


          <div className="Hero__TextBox-box5">

            <div className="Hero__TextBox-box5-individual">
              <img src={bikeimg} alt="bike" />
                <h3 className="card-title">  
                Standard Service
                </h3>
              <h4 className="card-title2">start price</h4>
              <h3 className="card-price">£60</h3>
              <Link to="/StandardService">
                <button className="letsExplore-btn">
                  Lets Explore
                </button>
              </Link>

            </div>

            <div className="Hero__TextBox-box5-standard">
              <img src={bikeimg} alt="bike" />
              
                <h3 className="card-title">
                  Advanced Service
                </h3>
              
              <h4 className="card-title2">start price</h4>
              <h3 className="card-price">£95</h3>
              <Link to="/AdvancedService">
                <button className="letsExplore-btn">
                Lets Explore
                </button>
              </Link>
            </div>

            <div className="Hero__TextBox-box5-gold">
              <img src={bikeimg} alt="bike" />
              <h3 className="card-title">Full Service</h3>
              <h4 className="card-title2">start price</h4>
              <h3 className="card-price">£145</h3>
              <Link to="/FullService">
                <button className="letsExplore-btn">
                Lets Explore
                </button>
              </Link>
            </div>

          </div>

        </main>

      </section>
      <section className="Hero__ImgBox">

        <img className="Hero__ImgBox--img"src={dansvan} alt="dans van with number" />
        
        <div className="Hero__ImgBox--whitebar"></div>
      </section>
    
    </div>
   );
}
 
export default Hero;